/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { RightOutlined } from '@ant-design/icons'
import { Divider } from 'antd'
import React, { Fragment } from 'react'

import CategorySegmentImage from '../CategorySegment/Image'
import { MemberProps } from '../convention'

type Props = {
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const CategoryListItem: React.FC<MemberProps<ICategory, Props>> = ({
  member,
  props: { onClick }
}) => {
  return (
    <Fragment>
      <Divider className="my-0" />
      <div onClick={onClick} className="full-width d-flex align-items-center py-2 pointer">
        <CategorySegmentImage member={member} />
        <h6 className="mb-0 ml-3">{member.label}</h6>
        <span className="ml-auto">
          <RightOutlined />
        </span>
      </div>
    </Fragment>
  )
}

export default CategoryListItem
